module.exports = __webpack_public_path__ + "img/wysjfw3.72f2b7d7.png";